export const getObjectPath = (p: any, o: any) => p.reduce((xs: any, x: any) => (xs && xs[x] ? xs[x] : null), o);
